export interface IUserStatusState {
  selectedOption: string | null;
}

export enum UserStatusActionType {
  SET_OPTION = 'SET_OPTION',
  CLEAR_OPTION = 'CLEAR_OPTION',
}

export type UserStatusAction =
  | { type: UserStatusActionType.SET_OPTION; payload: string }
  | { type: UserStatusActionType.CLEAR_OPTION };

export const initialUserStatusState: IUserStatusState = {
  selectedOption: localStorage.getItem('selectedOption') || null,
};

export const userStatusReducer = (
  state: IUserStatusState,
  action: UserStatusAction,
): IUserStatusState => {
  switch (action.type) {
    case UserStatusActionType.SET_OPTION:
      localStorage.setItem('selectedOption', action.payload);
      return { selectedOption: action.payload };
    case UserStatusActionType.CLEAR_OPTION:
      localStorage.removeItem('selectedOption');
      return { selectedOption: null };
    default:
      return state;
  }
};
